var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`section-content-background ${_vm.useBgColor ?  'bg-secondary' : ''}`},[_c('div',{class:`section-content-wrapper ${_vm.className ? _vm.className : ''} ${_vm.paddingSm ? 'padding-sm' : ''} ${_vm.noPaddingBottom ? 'no-padding-bottom' : ''}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }